module.exports = __webpack_public_path__ + "img/close-black.765c6f22.svg";